import { Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

/**
 * Tracks whether the most recently started navigation was a browser back/forward
 * (popstate) vs. an in-app link/router call. A per-component `PlatformLocation.onPopState`
 * listener can't answer this reliably: popstate fires while the OLD routed component is
 * still alive, and the NEW component (the one that needs the answer) isn't constructed,
 * and so isn't listening, until after the event has already been dispatched. This service
 * is a singleton that starts listening once at app bootstrap, so by the time a freshly
 * routed component asks in its constructor/ngOnInit, the answer is already recorded.
 */
@Injectable({
  providedIn: 'root',
})
export class BackNavigationService {
  private _isBackNavigation = false;

  constructor(router: Router) {
    router.events.pipe(filter((e): e is NavigationStart => e instanceof NavigationStart)).subscribe((e) => {
      this._isBackNavigation = e.navigationTrigger === 'popstate';
    });
  }

  get isBackNavigation(): boolean {
    return this._isBackNavigation;
  }
}
